import { UseMutationResult } from '@tanstack/react-query'
import { graphql } from 'src/gql'
import { MutateSendEeocByCandidateMutation, MutateSendEeocByCandidateMutationVariables } from 'src/gql/graphql'
import { useGraphMutation } from 'src/hooks/useGraphMutation'
import { useInvalidateQueryByDocument, useResetQuery } from 'src/hooks/useGraphQL'
import { candidateCreatedUpdatedByIdDocument } from '../../candidate/useCandidateCreatedUpdatedById'
import { eeocByCandidateDocument } from '../useEeocByCandidate'

const document = graphql(/* graphql */`
  mutation mutateSendEeocByCandidate($candidate: MongoID!, $voidReason: String) {
    cat {
      eeoc {
        sendEeocByCandidate(candidate: $candidate, voidReason: $voidReason) {
          _id
          candidate
        }
      }
    }
  }
`)

export type UseMutateSendEeocByCandidateReturn = UseMutationResult<
MutateSendEeocByCandidateMutation,
unknown,
MutateSendEeocByCandidateMutationVariables
>

const useMutateSendEeocByCandidate = (): UseMutateSendEeocByCandidateReturn => {
  const invalidateCreatedUpdated = useInvalidateQueryByDocument(candidateCreatedUpdatedByIdDocument)
  const resetEeoc = useResetQuery(eeocByCandidateDocument)
  return useGraphMutation(document, {
    onSuccess: (data) => {
      const id = data.cat?.eeoc?.sendEeocByCandidate?.candidate
      if (typeof id === 'string') {
        void invalidateCreatedUpdated({ id })
        void resetEeoc({ candidate: id })
      }
    }
  })
}

export { useMutateSendEeocByCandidate, document as mutateSendEeocByCandidateDocument }
